import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Layout } from '../components/layout/Layout';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('payment_id');

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="h-10 w-10 text-red-400" />
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-4">Payment Cancelled</h1>
        
        <p className="text-zinc-400 mb-8">
          Your payment was cancelled. No charges were made to your account.
        </p>

        <div className="flex gap-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="btn-gold"
          >
            Try Again
          </button>
          <button
            onClick={() => navigate('/courses')}
            className="px-6 py-3 bg-zinc-800 text-white rounded-lg hover:bg-zinc-700 transition-colors"
          >
            Browse Courses
          </button>
        </div>

        <p className="text-sm text-zinc-500 mt-8">
          Need help? Contact us at{' '}
          <a href="mailto:hello@navigatelearning.io" className="text-navigate-gold hover:underline">
            hello@navigatelearning.io
          </a>
        </p>
      </div>
    </Layout>
  );
}
